/**
 * 取込中の塩基コードを固定長チャンクに詰め替える。
 * 全文を 1 本の配列に持たない（§0.1）ため、埋まったチャンクから順に外へ渡す。
 */

import { DEFAULT_CHUNK_SIZE } from '../constants';

export type ChunkEmitter = (index: number, codes: Uint8Array) => Promise<void> | void;

export class ChunkAccumulator {
  readonly chunkSize: number;
  private readonly emit: ChunkEmitter;
  private buffer: Uint8Array;
  private filled = 0;
  private nextIndex = 0;
  private total = 0;

  constructor(emit: ChunkEmitter, chunkSize: number = DEFAULT_CHUNK_SIZE) {
    this.chunkSize = chunkSize;
    this.emit = emit;
    this.buffer = new Uint8Array(chunkSize);
  }

  /** 追加済みの塩基数 */
  get length(): number {
    return this.total;
  }

  get chunkCount(): number {
    return this.nextIndex + (this.filled > 0 ? 1 : 0);
  }

  async push(codes: Uint8Array): Promise<void> {
    let offset = 0;
    while (offset < codes.length) {
      const take = Math.min(this.chunkSize - this.filled, codes.length - offset);
      this.buffer.set(codes.subarray(offset, offset + take), this.filled);
      this.filled += take;
      offset += take;
      this.total += take;
      if (this.filled === this.chunkSize) {
        await this.emit(this.nextIndex, this.buffer);
        this.nextIndex += 1;
        this.filled = 0;
        this.buffer = new Uint8Array(this.chunkSize);
      }
    }
  }

  /** 端数チャンクを出して確定する */
  async flush(): Promise<void> {
    if (this.filled === 0) return;
    await this.emit(this.nextIndex, this.buffer.subarray(0, this.filled));
    this.nextIndex += 1;
    this.filled = 0;
    this.buffer = new Uint8Array(this.chunkSize);
  }
}
